import { INavData } from '@coreui/angular';
import { Permission } from '../../models/permission.enum';
import { AppPage } from '../../models/app-page.enum';

export interface TypedNavItem extends INavData {
  id: AppPage;
  requiredPermission?: Permission;
  children?: TypedNavItem[];
}

export const navItems: TypedNavItem[] = [
  {
    id: AppPage.Dashboard,
    name: AppPage.Dashboard,
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
  },
  {
    id: AppPage.NotificationsCenter,
    name: AppPage.NotificationsCenter,
    url: '/rpm/notifications',
    iconComponent: { name: 'cil-monitor' }
  },
  {
    id: AppPage.CCMReviews,
    name: AppPage.CCMReviews,
    url: '/ccm/patients',
    iconComponent: { name: 'cil-library' }
  },
  {
    id: AppPage.BHIReviews,
    name: AppPage.BHIReviews,
    url: '/bhi/patients',
    iconComponent: { name: 'cil-description' }
  },
  {
    id: AppPage.RPMReviews,
    name: AppPage.RPMReviews,
    url: '/rpm/reviews',
    iconComponent: { name: 'cil-calendar-check' }
  },
  {
    id: AppPage.Reports,
    name: AppPage.Reports,
    iconComponent: { name: 'cil-file' },
    class: 'collapsable-nav-item',
    children: [
      {
        id: AppPage.ActiveDeviceUtilizationReport,
        name: AppPage.ActiveDeviceUtilizationReport,
        url: '/rpm/reports/active-device-utilization',
        iconComponent: { name: 'cil-chart' }
      }
    ]
  },
  {
    id: AppPage.QualityAudits,
    name: AppPage.QualityAudits,
    url: '/quality-audits',
    iconComponent: { name: 'cil-check-circle' },
    requiredPermission: Permission.CanAccessQualityAudit
  },
  {
    id: AppPage.Administration,
    name: AppPage.Administration,
    iconComponent: { name: 'cil-map' },
    class: 'collapsable-nav-item',
    children: [
      {
        id: AppPage.UserManagement,
        name: AppPage.UserManagement,
        url: '/administration/user-management',
        iconComponent: { name: 'cil-group' },
        requiredPermission: Permission.CanAccessUserManagement
      },
      {
        id: AppPage.Announcements,
        name: AppPage.Announcements,
        url: '/administration/announcements',
        iconComponent: { name: 'cil-bell' },
        requiredPermission: Permission.CanAccessAnnouncementManagement
      },
    ]
  }
];
